(function() {

    var selects = '.js-select';
    var $selects = $(selects);

    var brandSelect = '.js-brand-select';
    var $brandSelect = $(brandSelect);

    /**
     * Init selects only if not on a mobile device.
     */
    function styleSelects() {
        if( isMobile() ) {
            return;
        }
        // _styleSelects( $selects );
        _styleSelects( $brandSelect );
    }

    /**
     * Set filter state
     *
     * 1. Default value must be zero in HTML.
     */
    function setFilterState( $select ) {
        var alreadySet = ( $select.hasClass('is-set') ) ? true : false;
        var value = $select.val();
        var $selectricWrapper = $select.parent().parent('.selectric-wrapper');
        if( value === '0' || value === '' ) { /* [1] */
            $select.removeClass('is-set');
            $selectricWrapper.removeClass('is-set');
            return;
        }
        else {
            if( !alreadySet ) {
                $select.addClass('is-set');
                $selectricWrapper.addClass('is-set');
            }
        }
    }

    //	========================================================================  //
    //	On ready
    //	========================================================================  //

    onReady.callbacks.selects = function() {
        styleSelects();
        _resizeSelects( $selects );
        setFilterState( $selects );
    };

    //	========================================================================  //
    //	On change
    //	========================================================================  //

    $selects.on('change', function() {
        setFilterState( $(this) );
        _resizeSelects( $(this) );
    });

})();
